import { displayName, loginUrl, logoutUrl, type ClientPrincipal } from "./auth";

/** Fill the navbar's action area with My files / Sign in / Sign out according to auth state. */
export function renderNav(container: HTMLElement, principal: ClientPrincipal | null, currentPage: "generator" | "files"): void {
	container.replaceChildren();

	// Signed-in user's name comes first, then the page links, then Sign out.
	if (principal) {
		const who = document.createElement("span");
		who.className = "navbar-text small text-white-50 d-none d-sm-inline me-1";
		who.textContent = displayName(principal);
		container.appendChild(who);
	}

	if (currentPage !== "generator") {
		container.appendChild(link("/", "Generator", "btn btn-sm btn-outline-light"));
	}
	if (currentPage !== "files") {
		// Signed out: "My files" starts the sign-in and lands on the files page afterwards.
		container.appendChild(link(principal ? "/files/" : loginUrl("/files/"), "My files", "btn btn-sm btn-outline-light"));
	}

	if (principal) {
		container.appendChild(link(logoutUrl(), "Sign out", "btn btn-sm btn-light"));
	} else {
		container.appendChild(link(loginUrl(currentPage === "files" ? "/files/" : location.pathname), "Sign in", "btn btn-sm btn-light"));
	}
}

function link(href: string, text: string, className: string): HTMLAnchorElement {
	const a = document.createElement("a");
	a.href = href;
	a.textContent = text;
	a.className = className;
	return a;
}
